import React from "react";
import { useTranslation } from "react-i18next";
import { StatusBadge, StatusDot } from "../../styledComponents/common";

const StatusWithDot = ({ status }) => {
  const { t } = useTranslation();

  if (!status) {
    return (
      <StatusBadge status={null}>
        <StatusDot status={null} />
        -
      </StatusBadge>
    );
  }

  const normalizedStatus = status.toLowerCase();

  // Map status to translation key
  const getStatusText = () => {
    switch (normalizedStatus) {
      case "unscheduled":
        return t("unscheduled");
      case "ready to dispatch":
      case "scheduled":
        return t("scheduled");
      case "completed":
        return t("completed");
      case "partially complete":
        return t("partially_completed");
      case "totally missed":
        return t("totally_missed");
      case "late":
        return t("late");
      case "in progress":
        return t("in_progress");
      case "missed":
        return t("missed");
      case "complete":
        return t("complete");
      case "open":
        return t("open");
      case "in_progress": 
        return t("in_progress");
      case "completed":
        return t("completed");
      case "partially complete":
        return t("partially_completed");
      case "totally missed":
        return t("totally_missed");
      case "late":
        return t("late");
      case "pending":
        return t("pending");
      case "approved":
        return t("approved");
      case "rejected":
        return t("rejected");
      case "done":
        return t("done");
      case "not done":
        return t("not_done");
      case "unscheduled":
        return t("unscheduled");
      case "ready to dispatch":
        return t("ready_to_dispatch");
      case "scheduled":
        return t("scheduled");
      case "completed":
        return t("completed");
      case "partially complete":
        return t("partially_completed");
      case "totally missed":
        return t("totally_missed");
      case "late":
        return t("late");
      case "in progress":
        return t("in_progress");
      default:
        return "-";
    }
  };

  return (
    <StatusBadge status={normalizedStatus}>
      <StatusDot status={normalizedStatus} />
      {getStatusText()}
    </StatusBadge>
  );
};

export default StatusWithDot;

